import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  const isNewV1Theme = theme?.isNewV1Theme;
  return {
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: 10,
    },
    root: {
      width: '100%',
    },
    headerClass: {
      backgroundColor: '#cecece',
      textTransform: 'capitalize',
    },
    confirmationDialoge: {
      '& .MuiDialog-paperWidthSm': {
        height: '250px',
        width: '600px',
      },
    },
    para: {
      fontSize: '28px !important',
      fontWeight: 600,
      color: '#000',
    },
    InputLabel: {
      marginTop: 20,
    },
    TextField: {
      width: '100%',
      '& .MuiInputBase-formControl': {
        height: '43px !important',
      },
    },
    status: {
      display: 'contents',
    },
    tabController: {
      '& .MuiTab-textColorInherit ': {
        minWidth: '0px',
      },
    },
    appBar: {
      boxShadow: 'none !important',
    },
    ContactTabs: {
      marginTop: 'none !important',
      marginBottom: 'none !important',
      border: '3px solid #eeee',
    },
    paper: {
      width: '100%',
      // marginBottom: theme.spacing(2),
      border: '3px solid #eeee',
      marginLeft: '-41px !important',
    },
    backIconCls: {
      padding: '0px !important',
    },

    filterButton: isNewV1Theme
      ? {
          background: '#3F51B5',
          color: 'white',
          '&:hover': {
            background: '#3F51B5',
            opacity: 0.9,
          },
        }
      : {},
    footer: isNewV1Theme
      ? {
          display: 'flex',
          justifyContent: 'end',
        }
      : {},
    pageTitle: isNewV1Theme
      ? {
          padding: '15px 0 0 15px',
        }
      : {},
    gridContainer:{
        width: '100%',
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
    },
    containerDiv:{
      width: '100% !important', 
      padding: '10px', 
      margin : '0px !important',
    },
    lables:{
        color: '#78798E',
        fontSize: '12px',
        lineHeight: '17px',
        marginBottom:6
    },
    update:{
        borderRadius: "4px",
        border: "1px solid #3F51B5",
        background: "#3F51B5",
        color: '#fff',
        textTransform: 'capitalize',
        height: '30px',
        boxSizing: 'border-box',
        boxShadow: 'none',
        "&:hover": {
            background: "#303F9F",
            color: "#fff",
            boxShadow: 'none',
        },
    },
    cancel:{
       borderRadius: "4px", 
       border: "1px solid #3F51B5",
       color: '#3F51B5',
       background: "#fff",
       textTransform: 'capitalize',
       height: '30px',
       boxSizing: 'border-box',
       boxShadow: 'none',
       "&:hover": {
        boxShadow: 'none',       
       },
    	},
    buttonContainer:{
      borderTop: '1px solid #E0E0E0', 
      padding: 16,
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      gap: 10
    },
    textField: {
      width: '100%',
      '& .MuiOutlinedInput-input': {
      padding: '10px !important',
      fontSize: '12px',
      },
      '& .MuiOutlinedInput-input:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 1000px #fff inset !important',
      },
      '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#D5D6DD !important',  
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#303F9F !important',
      },

      '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#3F51B5 !important',
      },
    },
    chipSelect: {
        ...(isNewV1Theme ? { '& input': {
        },
      } : {}),
      ...(isNewV1Theme 
        ? {
          '& div[class^="ChipSelect-valueContainer"]': {
            padding: '8px !important',
            gap: 2,
        },    
          } 
          : {}),   
       ...(isNewV1Theme 
            ? { 
            '& .MuiChip-root': { 
              backgroundColor: '#fff !important',
              border: '1px solid #D5D6DD !important',
            },   
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#D5D6DD !important',  
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#303F9F !important',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3F51B5 !important',
            },
          } 
          : {}),   
    },
  };
});
